"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validators = require("./validators");
const extractFiles = variables => {
  const files = [];
  const walkTree = function (tree) {
    let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const mapped = Array.isArray(tree) ? tree : Object.assign({}, tree);
    Object.keys(mapped).forEach(key => {
      const value = mapped[key];
      const name = [...path, key].join(".");
      if ((0, _validators.isUploadFile)(value) || (0, _validators.isFileList)(value)) {
        const file = (0, _validators.isFileList)(value) ? Array.prototype.slice.call(value) : value;
        files.push({
          file,
          name
        });
        mapped[key] = name;
      } else if ((0, _validators.isObject)(value)) {
        mapped[key] = walkTree(value, name);
      }
    });
    return mapped;
  };
  return {
    files,
    variables: walkTree(variables)
  };
};
var _default = exports.default = extractFiles;
//# sourceMappingURL=extractFiles.js.map